import { jsx as t } from "react/jsx-runtime";
import r from "./cluster-marker-text.module.less.js";
const i = ({ numberOfStations: e, theme: s }) => /* @__PURE__ */ t("div", { className: [r.clusterSize, "body-s bold mb-0", r[s]].join(" "), children: e });
export {
  i as ClusterMarkerText,
  i as default
};
